import React, { useLayoutEffect, useRef } from 'react';
import { toSafeFragment } from '../lib/html';

// Renders sanitized rich text as DOM nodes — never injects an HTML string.
export const SafeHtml = ({ html, ...rest }) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    if (ref.current) ref.current.replaceChildren(toSafeFragment(html));
  }, [html]);
  return <div ref={ref} {...rest} />;
};

export default SafeHtml;
